// Bordereau de livraison sécurisé — impression A4, 3 exemplaires.
// Mise en page reprise du modèle DOCC « BL_DOCC_securise » ; les données, l'empreinte
// et le scellement viennent du serveur (rien n'est recalculé ni modifiable ici).
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'qrcode';
import { blAPI, settingsAPI } from '../services/api';
import { apiError, dateHeureFr, heure } from '../utils/format';

const COPIES = ['ORIGINAL CLIENT', 'COPIE TRANSPORTEUR', 'ARCHIVE DOCC'];
const WATERMARK = { 'ORIGINAL CLIENT': 'ORIGINAL', 'COPIE TRANSPORTEUR': 'COPIE TRANSPORTEUR', 'ARCHIVE DOCC': 'ARCHIVE' };

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&display=swap');
  :root{--navy:#12284C;--navy-2:#1E3A66;--paper:#fff;--workspace:#EBEEF3;--line:#D5DBE6;--line-soft:#E6EAF1;--ink:#0E1B33;--muted:#5B6675;--red:#B4232A;--green:#1B7A46;--amber:#B7791F}
  *{box-sizing:border-box}
  html,body{margin:0;padding:0}
  body{font-family:'Inter',system-ui,Arial,sans-serif;color:var(--ink);background:var(--workspace);-webkit-font-smoothing:antialiased}
  .mono{font-family:'IBM Plex Mono',ui-monospace,'Courier New',monospace}
  .topbar{position:sticky;top:0;z-index:20;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:12px 20px;background:var(--navy);color:#fff}
  .topbar h1{font-size:14px;margin:0;font-weight:700}
  .topbar p{margin:0;font-size:11px;opacity:.75}
  .topbar button{font-family:inherit;cursor:pointer;border:none;border-radius:8px;font-weight:600;font-size:13px;padding:9px 14px;background:#fff;color:var(--navy)}
  .preview-wrap{padding:24px;display:flex;flex-direction:column;align-items:center;gap:24px}
  .sheet{width:196mm;height:283mm;background:var(--paper);color:var(--ink);box-shadow:0 6px 30px rgba(14,27,51,.16);padding:5mm 6mm 2mm;position:relative;break-after:page;page-break-after:always;overflow:hidden}
  .sheet:last-child{break-after:auto;page-break-after:auto}
  .sheet-inner{transform-origin:top left}
  .wm{position:absolute;inset:0;pointer-events:none;overflow:hidden;display:grid;place-items:center}
  .wm span{font-family:'IBM Plex Mono',monospace;font-weight:600;color:rgba(18,40,76,.045);font-size:58px;transform:rotate(-30deg);white-space:nowrap;letter-spacing:6px}
  .wm.cancel span{color:rgba(180,35,42,.16);font-size:80px}
  .copy-tag{position:absolute;top:0;left:50%;transform:translateX(-50%);font-size:8px;font-weight:700;letter-spacing:1.2px;color:#fff;background:var(--navy);padding:2px 8px;border-radius:0 0 4px 4px}
  .sheet-head{display:flex;justify-content:space-between;gap:16px;border-bottom:2.5px solid var(--navy);padding-bottom:10px}
  .sh-logo{display:flex;gap:11px;align-items:flex-start;min-width:0}
  .sh-mark-img{width:54px;height:auto;flex:0 0 auto;display:block}
  .sh-co h3{margin:0;font-size:22px;color:var(--navy);letter-spacing:.5px;font-weight:800;line-height:1}
  .sh-co .desc{margin:2px 0 0;font-size:9.5px;color:var(--muted);line-height:1.4}
  .sh-co .legal{margin:3px 0 0;font-size:8px;color:var(--muted);letter-spacing:.1px}
  .sh-doc{text-align:right;flex:0 0 auto}
  .sh-doc .tag{font-size:8.5px;font-weight:700;letter-spacing:1px;color:var(--navy);border:1.5px solid var(--navy);border-radius:5px;padding:2px 7px;display:inline-block}
  .sh-doc .num{font-family:'IBM Plex Mono',monospace;color:var(--red);font-weight:600;font-size:17px;margin-top:6px;white-space:nowrap}
  .sh-doc .num small{display:block;font-size:8px;color:var(--muted);letter-spacing:1px;font-weight:600}
  .sh-doc .dt{font-family:'IBM Plex Mono',monospace;font-size:10px;color:var(--ink);margin-top:5px}
  .sec-title{font-size:9px;text-transform:uppercase;letter-spacing:1.2px;color:#fff;background:var(--navy);padding:4px 8px;border-radius:4px;font-weight:700;margin:10px 0 6px;display:inline-block}
  .grid2{display:grid;grid-template-columns:1fr 1fr;gap:6px 22px}
  .kv{display:flex;font-size:11px;line-height:1.4;border-bottom:1px dotted var(--line);padding:1px 0}
  .kv b{flex:0 0 auto;color:var(--muted);font-weight:600;width:118px}
  .kv span{flex:1;color:var(--ink);font-weight:600;min-height:16px;word-break:break-word}
  table.desg{width:100%;border-collapse:collapse;font-size:11px}
  table.desg th{background:#F1F4F9;border:1px solid var(--line);padding:5px 7px;text-align:left;font-size:9px;text-transform:uppercase;letter-spacing:.5px;color:var(--navy)}
  table.desg td{border:1px solid var(--line);padding:6px 7px;vertical-align:top}
  .td-n{width:26px;text-align:center;font-weight:700;color:var(--navy)}
  .td-q{width:60px;text-align:center;font-weight:700}
  .td-des{width:33%;font-weight:600}
  .ids-grid{display:flex;flex-wrap:wrap;gap:4px}
  .id-chip{font-family:'IBM Plex Mono',monospace;font-size:10px;font-weight:500;background:#F1F4F9;border:1px solid var(--line-soft);border-radius:5px;padding:1px 6px}
  .id-chip.dup{background:#FBE7E7;border-color:#efc4c4;color:var(--red)}
  .tot-row td{background:#F7F9FC;font-weight:700}
  .ids-meta{display:flex;justify-content:space-between;align-items:center;margin-top:6px;font-size:10px;color:var(--muted)}
  .ids-meta b{color:var(--ink)}
  .valid-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-top:4px}
  .vbox{border:1px solid var(--line);border-radius:6px;padding:9px}
  .vt{font-size:8.5px;text-transform:uppercase;letter-spacing:.6px;color:var(--navy);font-weight:700;margin-bottom:6px}
  .vrow{font-size:9.5px;color:var(--muted);margin-bottom:3px}
  .vrow b{color:var(--ink);font-weight:600}
  .stamp{height:48px;border:1px dashed var(--line);border-radius:5px;display:grid;place-items:center;margin-top:6px}
  .stamp span{font-size:8px;color:#aeb6c4;letter-spacing:.5px}
  .two{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:8px}
  .rbox{border:1px solid var(--line);border-radius:6px;padding:10px}
  .rbox .stamp{height:54px}
  .seal{margin-top:10px;border:1.5px solid var(--navy);border-radius:8px;overflow:hidden;display:grid;grid-template-columns:1fr auto}
  .seal-body{padding:10px 12px}
  .seal-status{display:inline-flex;align-items:center;gap:7px;font-size:10px;font-weight:700;letter-spacing:.6px;padding:3px 9px;border-radius:20px;text-transform:uppercase}
  .seal-status.sealed{background:#E7F4EC;color:var(--green)}
  .seal-status.open{background:#FBF0DC;color:var(--amber)}
  .seal-status.cancel{background:#FBE7E7;color:var(--red)}
  .dot{width:7px;height:7px;border-radius:50%;background:currentColor;display:inline-block}
  .seal-body h4{margin:9px 0 3px;font-size:8.5px;letter-spacing:1px;text-transform:uppercase;color:var(--muted);font-weight:700}
  .hash{font-family:'IBM Plex Mono',monospace;font-size:10px;font-weight:500;color:var(--navy);word-break:break-all;line-height:1.5}
  .vcode{font-family:'IBM Plex Mono',monospace;font-size:15px;font-weight:600;letter-spacing:2px;color:var(--ink)}
  .seal-qr{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:10px 12px;border-left:1.5px solid var(--navy);background:#F7F9FC}
  .seal-qr img,.seal-qr .noqr{width:96px;height:96px}
  .seal-qr .noqr{border:1px dashed var(--line);border-radius:5px;display:grid;place-items:center;font-size:8px;color:#aeb6c4;text-align:center;padding:6px}
  .seal-qr small{font-size:7.5px;color:var(--muted);text-align:center;line-height:1.3;max-width:96px}
  .footnote{margin-top:8px;font-size:8px;color:var(--muted);line-height:1.5;border-top:1px solid var(--line);padding-top:6px}
  .footnote b{color:var(--navy)}
  .footnote .cur{text-decoration:underline}
  @media print{
    body{background:#fff}
    .topbar{display:none !important}
    .preview-wrap{padding:0;gap:0;display:block}
    .sheet{box-shadow:none;margin:0}
    @page{size:A4;margin:7mm}
    .vbox,.rbox,.seal{break-inside:avoid}
    table.desg tr{break-inside:avoid}
  }
`;

const BLPrint = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [settings, setSettings] = useState(null);
  const [qr, setQr] = useState(null);
  const [error, setError] = useState('');
  const wrapRef = useRef(null);

  useEffect(() => {
    Promise.all([blAPI.get(id), settingsAPI.get()])
      .then(async ([b, s]) => {
        setData(b.data);
        setSettings(s.data);
        const d = b.data.delivery;
        document.title = d.bl_numero || 'Bon de livraison';
        if (d.status === 'VALIDEE' && d.code_verification) {
          const base = s.data.url_verification || window.location.origin;
          const url = `${base}/verifier/${encodeURIComponent(d.bl_numero)}?code=${d.code_verification}`;
          setQr(await QRCode.toDataURL(url, { margin: 0, width: 240, errorCorrectionLevel: 'M', color: { dark: '#12284C', light: '#FFFFFF' } }));
        }
      })
      .catch((err) => setError(apiError(err)));
  }, [id]);

  // Chaque exemplaire doit tenir sur une page A4 (283 mm utiles) : réduction automatique si nécessaire
  useLayoutEffect(() => {
    if (!data || !settings) return undefined;
    const fit = () => {
      const max = (283 * 96) / 25.4;
      wrapRef.current?.querySelectorAll('.sheet').forEach((sheet) => {
        const inner = sheet.querySelector('.sheet-inner');
        inner.style.transform = '';
        inner.style.width = '';
        const pad = sheet.offsetHeight - sheet.clientHeight + 26; // marges internes
        const room = max - pad;
        const h = inner.scrollHeight;
        if (h > room) {
          const f = Math.floor((room / h) * 1000) / 1000;
          inner.style.transform = `scale(${f})`;
          inner.style.width = `${100 / f}%`;
        }
      });
    };
    fit();
    (document.fonts?.ready || Promise.resolve()).then(fit);
    window.addEventListener('beforeprint', fit);
    return () => window.removeEventListener('beforeprint', fit);
  }, [data, settings, qr]);

  if (error) return <div style={{ padding: 24 }}>{error}</div>;
  if (!data || !settings) return <div style={{ padding: 24 }}>Chargement…</div>;

  const { delivery: d, lines, validations } = data;
  const total = lines.reduce((s, l) => s + l.quantite, 0);
  const allIds = lines.flatMap((l) => l.numeros);
  const freq = new Map();
  allIds.forEach((x) => freq.set(x, (freq.get(x) || 0) + 1));
  const dupCount = allIds.length - freq.size;
  const lineOk = (l) => l.numeros.length === l.quantite;
  const conforme = total > 0 && dupCount === 0 && allIds.length === total && lines.every(lineOk);
  const sealed = d.status === 'VALIDEE';
  const cancelled = d.status === 'ANNULEE';
  const v = (n) => validations.find((x) => x.niveau === n);

  const globalCheck = dupCount > 0 ? { t: `⚠ ${dupCount} doublon(s)`, c: 'var(--red)', cell: 'Doublons' }
    : allIds.length !== total ? { t: `⚠ ${allIds.length} listés ≠ ${total} déclarés`, c: 'var(--red)', cell: 'Écart' }
      : !lines.every(lineOk) ? { t: '⚠ écart sur une désignation', c: 'var(--red)', cell: 'Écart' }
        : { t: '✓ Conforme', c: 'var(--green)', cell: '✓' };

  const legal = [
    settings.rccm && `RC : ${settings.rccm}`,
    settings.ninea && `NINEA : ${settings.ninea}`,
    settings.capital_social && `Capital social : ${settings.capital_social}`,
    settings.bl_telephone && `Tél. ${settings.bl_telephone}`,
  ].filter(Boolean).join(' — ');

  const Sheet = ({ copy }) => (
    <div className="sheet">
      <div className={`wm${cancelled ? ' cancel' : ''}`}>
        <span>{cancelled ? 'BL ANNULÉ' : `DOCC · ${d.bl_numero} · ${WATERMARK[copy]}`}</span>
      </div>
      <div className="copy-tag">{copy}</div>
      <div className="sheet-inner">

      <div className="sheet-head">
        <div className="sh-logo">
          <img className="sh-mark-img" src="/logo-docc.png" alt="Logo DOCC" />
          <div className="sh-co">
            <h3>{settings.raison_sociale}</h3>
            <p className="desc">{[settings.activite, settings.bl_adresse].filter(Boolean).join(' · ')}</p>
            <p className="legal">{legal}</p>
          </div>
        </div>
        <div className="sh-doc">
          <span className="tag">BORDEREAU SÉCURISÉ</span>
          <div className="num"><small>N° UNIQUE</small>{d.bl_numero}</div>
          <div className="dt">Émis le {dateHeureFr(d.emis_le)}</div>
        </div>
      </div>

      <span className="sec-title">Livraison</span>
      <div className="grid2">
        <div className="kv"><b>Client</b><span>{d.client_name || '—'}</span></div>
        <div className="kv"><b>Destination</b><span>{d.destination || '—'}</span></div>
        <div className="kv"><b>Commande / réf.</b><span>{d.commande_ref || '—'}</span></div>
        <div className="kv"><b>Total poteaux</b><span>{total} U ({lines.length} désignation{lines.length > 1 ? 's' : ''})</span></div>
      </div>

      <span className="sec-title">Désignations des poteaux livrés</span>
      <table className="desg">
        <thead><tr><th className="td-n">N°</th><th>Désignation (type homologué)</th><th className="td-q">Qté</th><th>Numéros des poteaux livrés</th></tr></thead>
        <tbody>
          {lines.map((l, i) => (
            <tr key={l.pba_type}>
              <td className="td-n">{i + 1}</td>
              <td className="td-des">{l.designation}</td>
              <td className="td-q">{l.quantite}</td>
              <td>
                <div className="ids-grid">
                  {l.numeros.length
                    ? l.numeros.map((x) => <span key={x} className={`id-chip${freq.get(x) > 1 ? ' dup' : ''}`}>{x}</span>)
                    : <span style={{ color: '#aeb6c4', fontSize: 10 }}>—</span>}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot><tr className="tot-row"><td /><td>TOTAL QUANTITÉ LIVRÉE</td><td className="td-q">{total} U</td><td>{globalCheck.cell}</td></tr></tfoot>
      </table>
      <div className="ids-meta">
        <span><b>{allIds.length}</b> numéros listés · <b>{dupCount}</b> doublon(s)</span>
        <span style={{ color: globalCheck.c, fontWeight: 600 }}>{globalCheck.t}</span>
      </div>

      <span className="sec-title">Transport / chauffeur</span>
      <div className="grid2">
        <div className="kv"><b>Transporteur</b><span>{d.transporteur || '—'}</span></div>
        <div className="kv"><b>Chauffeur</b><span>{d.chauffeur || '—'}</span></div>
        <div className="kv"><b>N° permis de conduire</b><span>{d.permis_conduire || '—'}</span></div>
        <div className="kv"><b>Immatric.</b><span>{d.immatriculation || '—'}</span></div>
        <div className="kv"><b>Téléphone</b><span>{d.telephone_chauffeur || '—'}</span></div>
        <div className="kv"><b>Heure Entrée usine</b><span>{heure(d.heure_entree) || '—'}</span></div>
        <div className="kv"><b>Heure Sortie usine</b><span>{heure(d.heure_sortie) || '—'}</span></div>
      </div>

      <span className="sec-title">Validation à 3 niveaux · fonctions séparées</span>
      <div className="valid-grid">
        {['1 · Stock', '2 · Logistique', '3 · Contrôle indépendant'].map((label, i) => {
          const val = v(i + 1);
          return (
            <div className="vbox" key={label}>
              <div className="vt">{label}</div>
              <div className="vrow">Nom : <b>{val?.nom || '—'}</b></div>
              <div className="vrow">Code : <b>{val?.code || '—'}</b></div>
              <div className="vrow">Validé le : <b>{val ? dateHeureFr(val.valide_le) : '—'}</b></div>
              <div className="stamp"><span>Signature &amp; cachet</span></div>
            </div>
          );
        })}
      </div>

      <div className="two">
        <div className="rbox">
          <div className="vt">Transporteur / chauffeur — reçu conforme</div>
          <div className="vrow">Nom : <b>{d.chauffeur || '—'}</b> &nbsp;·&nbsp; {d.transporteur || '—'}</div>
          <div className="stamp"><span>Signature &amp; cachet</span></div>
        </div>
        <div className="rbox">
          <div className="vt">Réception par le client {d.client_name ? `(${d.client_name})` : ''}</div>
          <div className="vrow">Nom &amp; fonction : ___________________ &nbsp; Date : _________</div>
          <div className="stamp"><span>Signature &amp; cachet</span></div>
        </div>
      </div>

      <div className="seal">
        <div className="seal-body">
          {cancelled ? (
            <span className="seal-status cancel"><span className="dot" />BL annulé — sans valeur</span>
          ) : sealed ? (
            <span className="seal-status sealed"><span className="dot" />Scellé le {dateHeureFr(d.scelle_le)} — 3 validations</span>
          ) : (
            <span className="seal-status open"><span className="dot" />Brouillon — compléter avant scellement{conforme ? '' : ' (écart à corriger)'}</span>
          )}
          <h4>Empreinte numérique SHA-256</h4>
          <div className="hash">{d.empreinte || '— calculée et enregistrée au scellement (3e validation)'}</div>
          <h4 style={{ marginTop: 8 }}>Code de vérification</h4>
          <div className="vcode">{d.code_verification || '—'}</div>
        </div>
        <div className="seal-qr">
          {qr ? <img src={qr} alt="QR de vérification" /> : <div className="noqr">QR généré au scellement</div>}
          <small>Scannez pour vérifier au registre central</small>
        </div>
      </div>

      <div className="footnote">
        <b>{(settings.bl_mentions || '').split(' — ')[0]}</b>
        {(settings.bl_mentions || '').includes(' — ') ? ` — ${settings.bl_mentions.split(' — ').slice(1).join(' — ')}` : ''} &nbsp;
        <b>SÉCURITÉ :</b> numéro jamais réutilisé — aucune rature ni surcharge — aucune sortie sans les 3 validations —
        toute modification change l'empreinte SHA-256 et annule la validité. Exemplaires au même ID :{' '}
        {COPIES.map((c, i) => (
          <React.Fragment key={c}>
            <b className={c === copy ? 'cur' : ''}>{c}</b>{i < COPIES.length - 1 ? ' / ' : '.'}
          </React.Fragment>
        ))}
      </div>
      </div>
    </div>
  );

  return (
    <>
      <style>{css}</style>
      <div className="topbar">
        <div>
          <h1>Bordereau de livraison sécurisé — {d.bl_numero}</h1>
          <p>{sealed ? 'Scellé' : cancelled ? 'Annulé' : 'Brouillon'} · 3 exemplaires · scellement SHA-256 + QR de vérification</p>
        </div>
        <button onClick={() => window.print()}>Imprimer / PDF</button>
      </div>
      <div className="preview-wrap" ref={wrapRef}>
        {COPIES.map((c) => <Sheet key={c} copy={c} />)}
      </div>
    </>
  );
};

export default BLPrint;
